"use client"

import clsx from "clsx"

import type { Nullish, PropsWithClassName } from "~/@types/generics"
import { useJoinStories } from "~/hooks/useJoinStories"

import * as css from "./styles.css"

export type JoinStoriesMockProps = PropsWithClassName<{
  handle: Nullish<string>
}>

function JoinStoriesMock({ className, handle }: JoinStoriesMockProps) {
  const { JoinStoriesScript, defaultAlias, productAlias, joinWidgetPreAlias } = useJoinStories({ handle })

  if (!handle) return null

  return (
    <div className={clsx(className, css.JoinStoriesMock)}>
      <JoinStoriesScript />
      <div
        className={css.joinStoriesWidget}
        id={`${joinWidgetPreAlias}-${productAlias}`}
        key={`${joinWidgetPreAlias}-${productAlias}`}
      />
      <div
        className={css.joinStoriesWidget}
        id={`${joinWidgetPreAlias}-${defaultAlias}`}
        key={`${joinWidgetPreAlias}-${defaultAlias}`}
      />
    </div>
  )
}

export default JoinStoriesMock
